export default __webpack_public_path__ + "static/media/crd.a964d02b.svg";